import { productReviewsPath } from "@travily/routes";
import type ListingsReviewsNew from "@travily/types/pages/ListingsReviewsNew";
import type { ReactNode } from "react";
import { ReviewFormModal } from "@/components/ReviewFormModal";
import { ProductReviewNewView } from "./new.view";

const ProductReviewNewPage = ({ listing_sqid, grant_token, name_required }: ListingsReviewsNew) => (
  <ProductReviewNewView>
    <ReviewFormModal grantToken={grant_token} nameRequired={name_required} path={productReviewsPath(listing_sqid)} />
  </ProductReviewNewView>
);

ProductReviewNewPage.layout = (page: ReactNode) => page;

export default ProductReviewNewPage;
